<template>
  <a href="#" class="btn other-v-btn" @click.prevent="toggle">
    <span class="material-icons visibility-icon" :class="{ off: !visibility }">
      {{ visibility ? "visibility" : "visibility_off" }}
    </span>
    {{ label }}
  </a>
</template>

<script>
export default {
  name: "LayerVisibilityButton",
  props: {
    label: { type: String, required: true },
    layerId: { type: String, required: true },
  },
  data() {
    return {
      visibility: true,
    };
  },
  methods: {
    toggle() {
      this.visibility = !this.visibility;
      this.$emit("change", {
        layerId: this.layerId,
        isVisible: this.visibility,
      });
    },
  },
};
</script>

<style scoped lang="scss">
.visibility-icon {
  font-size: 20px;
  vertical-align: middle;
  margin-right: 4px;
  color: white;

  &.off {
    color: #888888;
  }
}

.other-v-btn {
  display: inline-flex;
  align-items: center;
  padding: 6px 10px;
  background: #333;
  border-radius: 4px;
  text-decoration: none;
  color: white;
  font-size: 14px;

  &:hover {
    background: #555;
  }
}
</style>
